export default {
  edit_profile: 'Modifier votre profile',
  my_account: 'Mon compte',
  balance: 'Solde',
  available_for_withdrawal: 'Disponible pour retrait',
  amount_in_hold: 'Montant en attente',
  latest_news: 'Dernières annonces',
  more_news: 'Plus d\'actualités'
};